import React from 'react';
import LanguageButton from '../LanguageButton';
import styles from './LanguageHeader.module.scss';

export type LanguageHeaderProps = {
  brandName?: string;
};

const LanguageHeader: React.FC<LanguageHeaderProps> = ({ brandName = '' }) => {
  return (
    <div className={styles.languageHeader}>
      <div className={styles.brandNameWrapper}>
        {brandName.length > 25 ? (
          <strong className={styles.brandName}>{brandName}</strong>
        ) : (
          <strong>{brandName}</strong>
        )}
      </div>
      <LanguageButton />
    </div>
  );
};

export default LanguageHeader;
